import React from 'react';

import { Select } from '@metarouter-private/mr-mui';

import useEventsRequestedSelectProps from './useEventsRequestedSelectProps';

export default function EventDebuggerEventsRequestedSelect() {
  const props = useEventsRequestedSelectProps();
  return <Select {...props} />;
}
